import { gql } from 'urql';

const GetSsnExists = gql`
  query SsnExists {
    user {
      customerInfo {
        ssnExists
      }
    }
  }
`;

export default GetSsnExists;
